import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom/cjs/react-router-dom"
import { generatePath, useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useAlert } from "../../../../../hooks/useAlert"
import * as qs from "query-string"
import Loader from "../../../../../components/ui/loader"
import { TablePagination } from "@material-ui/core"
import Table, {
  recordsPerPageOptions,
} from "../../../../../components/v2/table/table"
import styled from "@emotion/styled/macro"
import { colors } from "../../../../../library/constants/styles/colors"
import {
  clearLearnerKnowmapKnowmixSteps,
  getLearnerKnowmapKnowmixSteps,
} from "../../../../../library/store/actions/creators/knowmapCreators"
import { KeyboardArrowRightOutlined } from "@material-ui/icons"
import * as routes from "../../../../../library/constants/routes"
import withErrorBoundary from "../../../../../hocs/guards/withErrorBoundary"
import StepTakeModal from "../../../knowmix/knowmixSingle/workModals/stepTakeModal"

const columns = [
  {
    id: 2,
    label: "Step",
  },
  {
    id: 5,
    label: "Course",
  },
  {
    id: 1,
    label: "Examiner",
  },
  {
    id: 3,
    label: "Status",
  },
  {
    id: 4,
    label: "Grade",
  },
]

const Container = styled.div`
  padding: 15px 10px;
  box-shadow: 0 0 2px 0 ${colors.black12};
  background-color: ${colors.white};
  border-radius: 2px;
`

const KnowmapLearnerKnowmixSteps = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const { errorAlert } = useAlert()

  const [name, setName] = useState("")

  const { learnerKnowmixSteps } = useSelector(({ knowmap }) => knowmap)
  const userId = useSelector(({ auth }) => auth.userData.id)

  const [page, setPage] = useState(0)
  const [recordsPerPage, setRecordsPerPage] = useState(recordsPerPageOptions[0])

  const [dataReceived, setDataReceived] = useState(false)
  const [changingPage, setChangingPage] = useState(false)

  const onSearch = (event) => {
    event.preventDefault()

    history.push({
      search: name.trim().length ? `?q=${name.trim()}` : undefined,
    })
  }

  const fetchData = async (offset = 0, shouldPageChange = false) => {
    const { q } = qs.parse(location.search)
    try {
      if (shouldPageChange) setChangingPage(true)

      await dispatch(
        getLearnerKnowmapKnowmixSteps({
          // name: q || undefined,
          limit: recordsPerPage,
          offset,
        })
      )

      setDataReceived(true)

      if (shouldPageChange) setChangingPage(false)
    } catch (e) {
      errorAlert(e)
    }
  }

  useEffect(() => {
    const { q } = qs.parse(location.search)

    if (typeof q === "string") {
      setName(q)
    }

    fetchData()

    return dispatch(clearLearnerKnowmapKnowmixSteps())
  }, [])

  useEffect(() => {
    if (dataReceived) {
      fetchData()
      setPage(0)
    }
  }, [location.search])

  useEffect(() => {
    if (dataReceived && !changingPage) {
      fetchData(learnerKnowmixSteps.availableOffsets[page], true)
    }
  }, [page])

  useEffect(() => {
    if (dataReceived && !changingPage) {
      fetchData()
      setPage(0)
    }
  }, [recordsPerPage])

  const [stepModalOpen, setStepModalOpen] = useState(false)
  const [activeStep, setActiveStep] = useState(null)
  const onStepModalOpen = (record) => {
    setActiveStep({ id: record.step.id, knowmixId: record.knowmix.id })
    setStepModalOpen(true)
  }
  const onStepModalClose = () => {
    setActiveStep(null)
    setStepModalOpen(false)
  }

  return (
    <>
      <div className="box">
        <div className="box__heading">Steps</div>
      </div>

      {dataReceived ? (
        <Container>
          {/*<div className="mb15">*/}
          {/*  <div className="search-form search-form--compact">*/}
          {/*    <div className="search-form__icon">*/}
          {/*      <SearchOutlined />*/}
          {/*    </div>*/}
          {/*    <form onSubmit={onSearch}>*/}
          {/*      <input*/}
          {/*        type="text"*/}
          {/*        id="search"*/}
          {/*        name="search"*/}
          {/*        placeholder="Search steps"*/}
          {/*        className="search-form__field"*/}
          {/*        autoComplete="off"*/}
          {/*        value={name}*/}
          {/*        onChange={(e) => setName(e.target.value)}*/}
          {/*      />*/}
          {/*    </form>*/}
          {/*  </div>*/}
          {/*</div>*/}
          <Table
            columns={columns}
            data={learnerKnowmixSteps.list}
            fluid={columns.length <= 5}
            changingPage={changingPage}
            actions={(record) => [
              {
                type: "button",
                label: () => (
                  <>
                    Review <KeyboardArrowRightOutlined />
                  </>
                ),
                onClick: () => onStepModalOpen(record),
              },
              // {
              //   type: "link",
              //   label: () => (
              //     <>
              //       Review <KeyboardArrowRightOutlined />
              //     </>
              //   ),
              //   path: {
              //     pathname: generatePath(routes.KNOWMIX_GRADES, {
              //       knowmixId: record.knowmix.id,
              //     }),
              //     search: `?stepId=${record.step.id}`,
              //   },
              // },
              // !record.grade
              //   ? {
              //       type: 'link',
              //       label: () => (
              //         <>
              //           Examine <KeyboardArrowRightOutlined />
              //         </>
              //       ),
              //       path: generatePath(routes.KNOWMIX_CHECK, {
              //         knowmixId: record.knowmix.id,
              //         checkId: record.id,
              //       }),
              //     }
              //   : {
              //       type: 'link',
              //       label: () => (
              //         <>
              //           Review <KeyboardArrowRightOutlined />
              //         </>
              //       ),
              //       path: {
              //         pathname: generatePath(routes.KNOWMIX_GRADES_CHECK, {
              //           knowmixId: record.knowmix.id,
              //           learnerId: record.learner.id,
              //         }),
              //         search: `?stepId=${record.step.id}`,
              //       },
              //     },
            ]}
          />

          <TablePagination
            count={learnerKnowmixSteps.total}
            page={page}
            onPageChange={(e, value) => setPage(value)}
            rowsPerPage={recordsPerPage}
            rowsPerPageOptions={recordsPerPageOptions}
            onRowsPerPageChange={(e) =>
              setRecordsPerPage(parseInt(e.target.value, 10))
            }
          />

          {stepModalOpen && !!activeStep && (
            <StepTakeModal
              knowmixId={activeStep.knowmixId}
              stepId={activeStep.id}
              open={stepModalOpen}
              onClose={onStepModalClose}
            />
          )}
        </Container>
      ) : (
        <Loader />
      )}
    </>
  )
}

export default withErrorBoundary(KnowmapLearnerKnowmixSteps)
